import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Moscow = ({ strokeWidth = 1.5 }): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M12 4L14.3511 8.76393L19.6085 9.52786L15.8042 13.2361L16.7023 18.4721L12 16L7.29772 18.4721L8.19577 13.2361L4.39155 9.52786L9.64886 8.76393L12 4Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    Moscow,
    'moscow',
);
